module.exports = __webpack_public_path__ + "img/sd_dacs.94ffbf09.jpg";